export class Controller
{
    /** @ngInject */

    constructor(
        ResellerCompanyResource,
        $state,
        Account
    )
    {
        this.ResellerCompanyResource = ResellerCompanyResource;
        this.$state = $state;
        this.Account = Account;
    }
    $onInit () {
        this.companyname="";
        this.domain="";
        this.isSaving = false;
    };


    save() {
        this.isSaving = true;
        this.ResellerCompanyResource.manageAnotherCompany(this.companyId, this.companyname, this.domain)
            .then((data)=>
                this.Account.reload()
                    .then(()=>{
                        this.$state.go('company.reseller.new-company',{createdCompany:data});
                })
            )
            .finally(()=>{
                this.isSaving = false;
            })
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/reseller/add-new-company/add-new-company.controller.js